import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const beneficiaryNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> =
  new Map([
    [
      ButtonActionType.MARK_FAVORITE_BENEFICIARY,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.REMOVE_FAVORITE_BENEFICIARY,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.BENEFICIARY_FORM_ADDRESS_PROCEED,
      {
        [ActionButtonOutcomesType.PROCESSING]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'beneficiary-bank-details',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'beneficiary-review',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
      },
    ],
    [
      ButtonActionType.BENEFICIARY_FORM_BANK_PROCEED,
      {
        [ActionButtonOutcomesType.PROCESSING]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'beneficiary-address-details',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'beneficiary-review',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
      },
    ],
    [
      ButtonActionType.BENEFICIARY_FORM_SUBMIT,
      {
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.FAILURE]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
      },
    ],
    [
      ButtonActionType.ADD_BENEFICIARY,
      {
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.FAILURE]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
      },
    ],
    [
      ButtonActionType.USE_SUGGESTED_NAME_COP,
      {
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.FAILURE]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
      },
    ],
    [
      ButtonActionType.BENEFICIARY_FORM_COP,
      {
        [ActionButtonOutcomesType.FAILURE]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'review-information-no-match-cop',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'review-information-match-cop',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
        [ActionButtonOutcomesType.PROCESSING]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'review-information-close-match-cop',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
        [ActionButtonOutcomesType.INCOMPLETE]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'review-information-secondary-identifier-required-cop',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
        [ActionButtonOutcomesType.ALTERNATE_1]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
        [ActionButtonOutcomesType.ALTERNATE_2]: {
          selectedZone: APP_ZONES.PAYMENT,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'select-beneficiary',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
      },
    ],
    [
      ButtonActionType.EDIT_BENEFICIARY_UNIFIED,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.REMOVE_BENEFICIARY,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      },
    ],
  ]);
